import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { UserRole } from '../models/general.models';
import RouteAuthorizer from './components/RouteAuthorizer';
import { AppRoutes } from './routes';
var subscriptionRedirectPages = [
    {
        userRole: UserRole.Anonymous,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.NoCountryUser,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.PartialUser,
        page: AppRoutes.JoinFamily,
    },
    {
        userRole: UserRole.PlanPendingUser,
        page: AppRoutes.OnboardingWelcomePage,
    },
    {
        userRole: UserRole.CompleteUser,
        page: AppRoutes.Plan,
    },
];
var SubscriptionPage = React.lazy(function () { return import('../pages/onboarding/subscription/subscription.page'); });
var subscriptionRoutes = [
    {
        path: "".concat(AppRoutes.SubscriptionPage),
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.UserPaymentNeeded], redirectPages: subscriptionRedirectPages, children: _jsx(SubscriptionPage, {}) })),
    },
];
export default subscriptionRoutes;
